import musicOpen from '@/assets/images/ic_because_play.png';
import musicClose from '@/assets/images/ic_because_close.png';
import musicOpen2 from '@/assets/images/ic_because_play2.png';
import musicClose2 from '@/assets/images/ic_because_close2.png';
import eshopMusicOpen from '@/assets/images/sound.png';
import eshopMusicClose from '@/assets/images/soundClose.png';
import timeState from '@/assets/images/chanllenge/ic_status.png';
import timeStateY from '@/assets/images/chanllenge/ic_time.png';
import wheelWinTmBg from '@/assets/images/ic_win@2x.png';
import wheelFailTmBg from '@/assets/images/ic_win_noPrize@2x.png';

// B-Background Skin, WB-Luck Wheel Background Skin, W-Wheet Skin,T-Title Skin, K-SPIN_SKIN, M-Background Music, P-Prize Music
export const ITEM_PART_TYPE = {
  BACKGROUND_SKIN: 'B',
  WHEET_BACKGROUND_SKIN: 'WB',
  WHEET_SKIN: 'W',
  TITLE_SKIN: 'T',
  SPIN_SKIN: 'K',
  BACKGROUND_MUSIC: 'M',
  PRIZE_MUSIC: 'P',
  SHARE_IMG: 'S',
  REGISTER_TITLE: 'KR',
  REGISTER_BACKGROUND: 'KB',
};

export const TASK_CNETER_SKIN = {
  BACKGROUND_SKIN: 'B',
  POP_SKIN: 'PP',
  GO_SKIN: 'B3',
  CLAIM_SKIN: 'B1',
  CLAIMED_SKIN: 'B2',
};

export const POSTPAID_ITEM_PART_TYPE = {
  BackgroundSkin: 'BN',
  CenterSkin1: 'C1',
  CenterSkin2: 'C2',
  Button1: 'B1',
};

// 后付费和预付费标签
export const POST_PRE_TAG_MAP = {
  2100: 'FWA',
  1200: 'FWAPOSTPAID',
};

export const POINT_REQUEST = {
  MAXAMOUNT: 100000,
  PIN_SIZE_LIMITATION: 4,
  CAPTCHA_SIZE_LIMITATION: 6,
  DEFAULT_PAGE_SIZE: 20,
  DEFAULT_CURRENT_PAGE: 1,
  QUERY_GAP: 60, // 查询间隔，单位秒
  OTP_GAP: 60, // 验证码间隔，单位秒
  REQUEST_PERFIX: '/api',
  LOGIN_PATH: '',
  LOGIN_URL: '/',
  BUY_PROMO_URL: '/download/buyPromoApp',
  SMS_OTP: 120, // 秒
  PHONE_PREFIX: '09', // 号码前缀
  SHORT_PREFIX: '9', // 号码前缀
  PayId: {
    Credit_DebitCard: {
      thirdPayChannelId: 29,
      thirdPayMethodId: 29,
      PayMethodName: 'Debit / Credit Card',
    },
    Alipay: { thirdPayChannelId: 501, thirdPayMethodId: 503, PayMethodName: 'Alipay' },
    WeChat: { thirdPayChannelId: 502, thirdPayMethodId: 505, PayMethodName: 'WeChat' },
    ipay88: { thirdPayChannelId: 31, thirdPayMethodId: 42, PayMethodName: 'GCash' },
    GcashOld: { thirdPayChannelId: 503, thirdPayMethodId: 510, PayMethodName: 'GCash' },
    GcashQyCode: { thirdPayChannelId: 41, thirdPayMethodId: 53, PayMethodName: 'GCash' },
    Gcash: { thirdPayChannelId: 503, thirdPayMethodId: 511, PayMethodName: 'GCash' },
    GrabPay: { thirdPayChannelId: 31, thirdPayMethodId: 43, PayMethodName: 'Grab' },
    GrabPayDirect: { thirdPayChannelId: 37, thirdPayMethodId: 44, PayMethodName: 'Grab' },
    GrabPayQyCode: { thirdPayChannelId: 37, thirdPayMethodId: 45, PayMethodName: 'Grab' },
    PayMayaQyCode: { thirdPayChannelId: 38, thirdPayMethodId: 48, PayMethodName: 'PayMaya' },
    PayMaya: { thirdPayChannelId: 38, thirdPayMethodId: 47, PayMethodName: 'PayMaya' },
    PointPay: { paymentMethodId: 9, PayMethodName: 'DITO Points' },
  },
};

// 开关，Y/N，音乐、视频默认打开/关闭
export const MEDIA_STATE = {
  OPEN: 'Y',
  CLOSE: 'N',
};

// 锦鲤夺宝 tab标签
export const TAB_TYPE = {
  RAFFLE: 0,
  PAST: 1,
  MINE: 2,
};

// 1:中奖未领取 2：参与未开奖 3：中奖已经领取 4：未中奖， 补充： 5 中奖未领取已过期
export const PARTICIPATION_STATUS = {
  WINPRIZE_NOTRECEIVED: '1',
  NO_PRIZE: '2',
  WINPRIZE_HASRECEIVED: '3',
  FAILED_WINPRIZE: '4',
  WINPRIZE_NOTRECEIVED_EXPIRED: '5',
};

// 抽奖类型，R: Roulettle lottery, N: Nine-gauge lottery, 'B','Lucky Box'，'K','Koi seizes the treasure',
export const LUCKY_DRAW_TYPE = {
  ROULETTLE_LOTTERY: 'R',
  NINE_GAUGE_LOTTERY: 'N',
  LUCKY_BOX: 'B',
  KOI_SEIZES_THE_TREASURE: 'K',
  SIGN_IN: 'S',
  C2C: 'C',
  TASK_CENTER: 'T', // 任务中心
};

// 属性脚本44-Enter Dead Date，45-Drawing Date
export const ATTR_TYPE = {
  ENTER_DEADLINE: '44',
  DRAWING_DATE: '45',
};

// 卡片类型
export const CARD_TYPE = {
  RAFFLE: 'R',
  MINE: 'M',
  PAST: 'P',
};

// 模板统一Key的定义
export const TemplateKey = {
  FRESH_SPRING_TEMPLATE: 'FRESH_SPRING_TEMPLATE',
  FESTIVE_SIMPLE_TEMPLATE: 'FESTIVE_SIMPLE_TEMPLATE',
  FRESH_SPRING_TEMPLATE_N: 'FRESH_SPRING_TEMPLATE_N',
  FESTIVE_SIMPLE_TEMPLATE_N: 'FESTIVE_SIMPLE_TEMPLATE_N',
  DARK_STAR_TEMPLATE: 'DARK_STAR_TEMPLATE',
  CHRISTMAS_DAY_TEMPLATE: 'CHRISTMAS_DAY_TEMPLATE',
  BRIGHT_YELLOW_TEMPL: 'BRIGHT_YELLOW_TEMPL',
  LOTTERY_WHEEL_PTO: 'LOTTERY_WHEEL_PTO',
  VIBRANT_ORANGE: 'VIBRANT_ORANGE',
  FANTASTIC_VIOLET: 'FANTASTIC_VIOLET',
  AUTUMN_ORANGE: 'AUTUMN_ORANGE',
  ANNIVRTSAY_CELEBRATION: 'ANNIVRTSAY_CELEBRATION',
  ESHOP_WHEEL_GAME1: 'ESHOP_WHEEL_GAME1',
};

export const TEMPLATE_NAME = {
  [TemplateKey.FRESH_SPRING_TEMPLATE]: 'Fresh Spring Template',
  [TemplateKey.FESTIVE_SIMPLE_TEMPLATE]: 'Festive Simple Template',
  [TemplateKey.FRESH_SPRING_TEMPLATE_N]: 'Fresh Simple Template N',
  [TemplateKey.FESTIVE_SIMPLE_TEMPLATE_N]: 'Festive Simple Template N',
  [TemplateKey.DARK_STAR_TEMPLATE]: 'Dark Star Template',
  [TemplateKey.CHRISTMAS_DAY_TEMPLATE]: 'Christmas Day Template',
  [TemplateKey.BRIGHT_YELLOW_TEMPL]: 'Bright Yellow Template',
  [TemplateKey.LOTTERY_WHEEL_PTO]: 'Large Turntable Lottery PTO',
  [TemplateKey.VIBRANT_ORANGE]: 'Vibrant Orange',
  [TemplateKey.FANTASTIC_VIOLET]: 'Fantastic Violet',
  [TemplateKey.AUTUMN_ORANGE]: 'Autumn Orange',
  [TemplateKey.ANNIVRTSAY_CELEBRATION]: 'Anniversary Celebration',
  [TemplateKey.ESHOP_WHEEL_GAME1]: 'eShopWheelGame1',
};

export const TEMPLATE_THEME = {
  [TemplateKey.FESTIVE_SIMPLE_TEMPLATE]: {
    noticeBg: 'rgba(67, 28, 153, 0.5)',
    ruleColor: '#fff',
    chanceTextColor: '#fff',
    chanceColor: '#FDF94A',
    rewardBtnBg: 'linear-gradient(#FFDF5F, #FFBB32)',
    rewardBtnColor: '#3D1492',
    wheelBgPadding: '1.37rem',
    splitColor: '#7021e9',
    musicOpen,
    musicClose,
    marginTop: 0,
  },
  [TemplateKey.FRESH_SPRING_TEMPLATE]: {
    noticeBg: 'rgba(0, 0, 0, 0.5)',
    ruleColor: '#09460D',
    chanceTextColor: '#17571C',
    chanceColor: '#DA2911',
    rewardBtnBg: 'linear-gradient(#EFFF00, #E46C14)',
    rewardBtnColor: '#17471B',
    wheelBgPadding: '1.22rem',
    splitColor: '#fff',
    musicOpen: musicOpen2,
    musicClose: musicClose2,
    marginTop: 0,
  },
  [TemplateKey.ESHOP_WHEEL_GAME1]: {
    musicOpen: eshopMusicOpen,
    musicClose: eshopMusicClose,
  },
  [TemplateKey.FESTIVE_SIMPLE_TEMPLATE_N]: {
    noticeBg: 'rgba(67, 28, 153, 0.5)',
    ruleColor: '#fff',
    chanceTextColor: '#fff',
    chanceColor: '#FDF94A',
    rewardBtnBg: 'linear-gradient(#FFDF5F, #FFBB32)',
    rewardBtnColor: '#3D1492',
    lotteryBgPadding: '0.81rem',
    musicOpen,
    musicClose,
    nineItemBg: '#5005b7',
    borderRadius: '0.06rem',
    itemBorderRadius: '0.06rem',
    selectedBorder: '2px solid #fdf94a',
    selectedBg: '#5005b7',
    bgMarginTop: '-0.41rem',
    // marginTop: '-0.3rem', 之前是-0.3rem，我看效果异常修改为0
    marginTop: 0,
    tempolateColor: 'purple',
  },
  [TemplateKey.FRESH_SPRING_TEMPLATE_N]: {
    noticeBg: 'rgba(0, 0, 0, 0.5)',
    ruleColor: '#09460D',
    chanceTextColor: '#17571C',
    chanceColor: '#DA2911',
    rewardBtnBg: 'linear-gradient(#EFFF00, #E46C14)',
    rewardBtnColor: '#17471B',
    lotteryBgPadding: '1.08rem',
    musicOpen: musicOpen2,
    musicClose: musicClose2,
    nineItemBg: '#FAE986',
    borderRadius: '0.23rem',
    itemBorderRadius: '0.23rem',
    selectedBorder: 'none',
    selectedBg: '#FCF9F5',
    bgMarginTop: '-0.61rem',
    marginTop: '0',
    tempolateColor: 'green',
  },
  [TemplateKey.LOTTERY_WHEEL_PTO]: {
    noticeBg: 'rgba(67, 28, 153, 0.5)',
    ruleColor: '#fff',
    chanceTextColor: '#fff',
    chanceColor: '#FDF94A',
    rewardBtnBg: '#FCD116',
    rewardBtnColor: '#3e3e3e',
    wheelBgPadding: '1.37rem',
    splitColor: '#7021e9',
    musicOpen,
    musicClose,
    marginTop: 0,
  },
  // DARK_START: {
  //   positionCon: 'none',
  //   // position: 'none',
  //   backgroundColor: 'transparent',
  //   background: '#080129',
  //   peopleBsck: '#2B2548',
  //   chrismas: 'dark',
  //   cutOffpadding: '0.25rem',
  //   notCutOffpadding: '0.35rem',
  //   timeBorder: '1px solid #c43886',
  //   textAlign: 'left',
  //   border: '1px solid #c43886',

  // },
  // CHRISTMAS: {
  //   chrismas: 'chrismas',
  //   backgroundColor: '#215541',
  //   peopleBsck: '#215541',
  //   positionCon: 'relative',
  //   // position: 'absolute',
  //   // top: '-0.14rem',
  //   background: 'rgba(0, 0, 0, 0.3)',
  //   listPaddingTop: '.14rem',
  //   timeBorder: '1px solid #FFCE14',
  //   textAlign: 'center',
  //   border: '1px solid #FFCE14',
  // },
  [TemplateKey.DARK_STAR_TEMPLATE]: {
    timeImg: timeState,
  },
  [TemplateKey.CHRISTMAS_DAY_TEMPLATE]: {
    timeImg: timeStateY,
    themeClassName: 'christmas',
    // hasPrizeBg: true,
  },
  [TemplateKey.BRIGHT_YELLOW_TEMPL]: {},
  // 马来TM 大转盘
  [TemplateKey.VIBRANT_ORANGE]: {
    noticeBg: 'rgba(0, 0, 0, 0.5)',
    ruleColor: '#fff',
    chanceTextColor: '#fff',
    chanceColor: '#fff',
    rewardBtnBg: 'linear-gradient(#FF8004, #E80000)',
    rewardBtnColor: '#FCF9F5',
    wheelBgPadding: '1.22rem',
    splitColor: '#fff',
    modalWinBg: wheelWinTmBg,
    modalFailBg: wheelFailTmBg,
    musicOpen,
    musicClose,
    marginTop: 0,
  },
  // 马来TM 锦鲤夺宝
  [TemplateKey.FANTASTIC_VIOLET]: {
    timeImg: timeState,
    themeClassName: 'violet',
  },
  // 马来TM 日常签到
  [TemplateKey.AUTUMN_ORANGE]: {
    themeClassName: 'orange',
  },
};

export const getTemplateTheme = (code = '') => {
  let themeKey = '';
  (Object.keys(TEMPLATE_NAME) || []).some(key => {
    if ((TEMPLATE_NAME[key] || '').toLocaleLowerCase() === code.toLocaleLowerCase()) {
      themeKey = key;
      return true;
    }
    return false;
  });
  return TEMPLATE_THEME[themeKey] || {};
};

// lotteryDraw  夺宝抽奖
// 夺宝抽奖的状态
export const LOTTERYDRAW = {
  NOT_START: '1',
  NOT_CUTOFF: '2',
  START: '3',
  END: '4',
  DRAWING: '5',
};

export const LOTTERYDRAW_TEMPLATE_NAME = {
  DARK_START: 'Dark Star Template',
  CHRISTMAS: 'Christmas Day Template',
};

export const LOTTERY_STATUS = {
  // notstart: 'D',
  Draft: 'N',
  Finished: 'E',
  NotStart: 'D',
  Ongoing: 'A',
  Suspended: 'S',
};

export const DEAD_TIME = 'ENTER_DEAD_DATE';

export const GetMoreChanceTheme = {
  ditoTheme: { textColor: '#ce1126', themeColor: '#ce1126', btnColor: '#ffffff' },
  proTheme: { textColor: '#ce1126', themeColor: '#FEC700', btnColor: '#3D3D3D' },
};

// 分享模板对应Key值
export const SHARE_SKIN_TYPE = {
  SHARE: 'S', // SHARE 默认
  SHARE_SMS: 'CS', // C2C SMS
  SHARE_EMAIL: 'CE', // C2C EMAIL
  SHARE_FACEBOOK: 'CF', // C2C FACEBOOK
};

export const C2C_FONT_FAMILY = {
  'Exo 2': 'Exo2-New',
  'HK Grotesk Wide': 'HKGroteskWide',
  Roboto: 'Roboto',
  Poppins: 'Poppins-Bold',
};

// Effective Time Type
export const EFFECTIVE_TIME_TYPE = [
  { value: 'A', labelKey: 'lb_offer_efftype_immediately' },
  { value: 'B', labelKey: 'lb_offer_efftype_next_day' },
  { value: 'C', labelKey: 'lb_offer_efftype_next_month' },
  { value: 'D', labelKey: 'lb_offer_efftype_specified_day' },
  { value: 'E', labelKey: 'lb_offer_efftype_next_billing_cycle' },
  { value: 'F', labelKey: 'lb_offer_efftype_next_week' },
];

export const CouponStateOption = {
  VALID: 'A',
  EXPIRED: 'B',
  USED: 'C',
};

export const VoucherStateList = [
  // {
  //   labelKey: 'lb_point_my_voucher_all',
  //   value: null,
  // },
  {
    labelKey: 'lb_point_my_voucher_valid',
    value: CouponStateOption.VALID,
    noDataTitleKey: 'lb_voucher_no_data_valid',
    noDataTipKey: 'tip_voucher_no_data_valid',
  },
  {
    labelKey: 'lb_point_my_voucher_expired',
    value: CouponStateOption.EXPIRED,
    noDataTitleKey: 'lb_voucher_no_data_expired',
    noDataTipKey: 'tip_voucher_no_data_expired',
  },
  {
    labelKey: 'lb_point_my_voucher_used',
    value: CouponStateOption.USED,
    noDataTitleKey: 'lb_voucher_no_data_used',
    noDataTipKey: 'tip_voucher_no_data_used',
  },
];
